import SiteLayout from "../components/site/SiteLayout";

const posts = [
  {
    title: "How Community Kitchens Are Reducing Child Malnutrition",
    date: "April 30, 2026",
    summary: "A behind-the-scenes look at our nutrition program and the volunteers who power it."
  },
  {
    title: "5 Ways Youth Volunteers Are Changing Rural Education",
    date: "April 15, 2026",
    summary: "Stories from our mentorship program that show what happens when students feel seen."
  },
  {
    title: "Campaign Spotlight: Clean Water Access",
    date: "March 26, 2026",
    summary: "Highlights from a campaign that brought clean water to 12 villages."
  }
];

function Blog() {
  return (
    <SiteLayout>
      <section className="page-hero">
        <div className="container">
          <h1>Blog</h1>
          <p>Field stories, campaign updates, and insights from the Hope Foundation team.</p>
        </div>
      </section>
      <section className="section">
        <div className="container">
          <div className="card-grid">
            {posts.map((post, index) => (
              <article className="card" key={post.title} style={{ "--i": index }}>
                <div className="news-meta">{post.date}</div>
                <h3>{post.title}</h3>
                <p>{post.summary}</p>
                <button className="btn btn-ghost" type="button">
                  Read Article
                </button>
              </article>
            ))}
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}

export default Blog;
